import styled from 'styled-components';
import { maxWidth } from 'config/constants';

export const StyledAppSideNav = styled.nav`
  ${maxWidth.l} {
    display: none;
  }

  width: 260px;
  min-width: 260px;
  background: ${(props): string => props.theme.kcc.colors.WHITE};
  border-right: ${(props): number => props.theme.kcc.lineWidth.BORDER}px solid
    ${(props): string => props.theme.kcc.colors.BORDER};
  align-self: stretch;
  overflow-y: auto;
  overflow-x: hidden;
  overscroll-behavior: none;
  transition: width 0.25s cubic-bezier(0.2, 0, 0, 1), min-width 0.25s cubic-bezier(0.2, 0, 0, 1);
  flex-shrink: 0;

  &.app-side-nav--collapsed {
    width: 0;
    min-width: 0;
    border-right: none;
    visibility: hidden;
    pointer-events: none;
  }

  .app-side-nav__inner {
    padding: ${(props): string => props.theme.kcc.spacing.BASE} 0;
    min-width: 260px;
  }

  .app-side-nav__section {
    display: flex;
    flex-direction: column;
  }

  .app-side-nav__section-title {
    padding: ${(props): string => props.theme.kcc.spacing.XS} ${(props): string => props.theme.kcc.spacing.BASE};
    padding-left: ${(props): string => props.theme.kcc.spacing.XL};
    padding-right: ${(props): string => props.theme.kcc.spacing.BASE};
    font-size: ${(props): number => props.theme.kcc.typography.FONT_SIZE.LG}px;
    font-family: ${(props): string => props.theme.kcc.typography.FONT_FAMILY};
    font-weight: ${(props): number => props.theme.kcc.typography.FONT_WEIGHT.EXTRA_BOLD};
    color: ${(props): string => props.theme.kcc.colors.TEXT};
    line-height: ${(props): number => props.theme.kcc.typography.LINE_HEIGHT.LG};
  }

  .app-side-nav__item {
    display: flex;
    align-items: center;
    width: 100%;
    padding-top: 10px;
    padding-bottom: 10px;
    padding-left: ${(props): string => props.theme.kcc.spacing.XL};
    padding-right: ${(props): string => props.theme.kcc.spacing.BASE};
    font-size: ${(props): number => props.theme.kcc.typography.FONT_SIZE.BASE}px;
    font-family: ${(props): string => props.theme.kcc.typography.FONT_FAMILY};
    font-weight: ${(props): number => props.theme.kcc.typography.FONT_WEIGHT.REGULAR};
    color: ${(props): string => props.theme.kcc.colors.TEXT};
    text-decoration: none;
    line-height: ${(props): number => props.theme.kcc.typography.LINE_HEIGHT.LG};
    transition: background 0.15s;

    &.active {
      font-weight: ${(props): number => props.theme.kcc.typography.FONT_WEIGHT.EXTRA_BOLD};
      color: ${(props): string => props.theme.kcc.colors.TEXT};
      text-decoration: underline;
      text-decoration-thickness: 3px;
      text-underline-offset: 3px;
      text-decoration-color: ${(props): string => props.theme.kcc.colors.TEXT};
    }
  }

  .app-side-nav__divider {
    height: ${(props): number => props.theme.kcc.lineWidth.BORDER}px;
    background: ${(props): string => props.theme.kcc.colors.BORDER};
    margin: ${(props): string => props.theme.kcc.spacing.XS} 0;
  }
`;
